var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ActiveDealsChart',{staticClass:"chart-container",attrs:{"options":_vm.options,"chart-data":_vm.datacollection,"height":64}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }